import { render, staticRenderFns } from "./AiMyprPrQuestionsForm.vue?vue&type=template&id=b6e011ae&scoped=true"
import script from "./AiMyprPrQuestionsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiMyprPrQuestionsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AiMyprPrQuestionsForm.vue?vue&type=style&index=0&id=b6e011ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e011ae",
  null
  
)

export default component.exports